var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisual(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "652px",
    height: "191px",
    viewBox: "0 0 652 191",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Sales overview visual") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6315",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9158",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "-3.33066907e-14%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5EDE8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F5",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "-3.33066907e-14%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE3D5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC8AB",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sales-overview-visual"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Arrow",
    d: "M326,84 L326,98 L330,98 L325.5,107 L321,98 L325,98 L325,84 L326,84 Z",
    fill: "#FF6315",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.5,97.5 C193.450114,98.2322861 199.775587,94.8989528 205.47642,87.5 C208.612743,83.4294526 208.808065,59.8823883 214.148023,50 C217.058941,44.6129121 223.5096,40.1129121 233.5,36.5",
    id: "Line",
    stroke: "#FF6315",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeDasharray: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.5,97.5 C193.781743,95.3360803 200.113178,98.9060149 205.494305,108.209804 C210,116 204.370603,132.811856 210,142.909928 C212.643493,147.651854 220.476826,150.515211 233.5,151.5",
    id: "Line-2",
    stroke: "#FF6315",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeDasharray: 5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-1)",
    x: 0,
    y: 0,
    width: 186,
    height: 95,
    rx: 16
  }), /*#__PURE__*/React.createElement("text", {
    id: "Margin",
    fontFamily: "Helvetica-Bold, Helvetica",
    fontSize: 12,
    fontWeight: "bold",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 11,
    y: 22
  }, "Margin"))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(466.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-2)",
    x: 0,
    y: 0,
    width: 186,
    height: 95,
    rx: 16
  }), /*#__PURE__*/React.createElement("text", {
    id: "Deferred-margin",
    fontFamily: "Helvetica-Bold, Helvetica",
    fontSize: 12,
    fontWeight: "bold",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 11,
    y: 22
  }, "Deferred margin"))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(233.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-3)",
    x: 0,
    y: 0,
    width: 186,
    height: 81,
    rx: 16
  }), /*#__PURE__*/React.createElement("text", {
    id: "On-order",
    fontFamily: "Helvetica-Bold, Helvetica",
    fontSize: 12,
    fontWeight: "bold",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 9,
    y: 22
  }, "On order"))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(233.000000, 110.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-3)",
    x: 0,
    y: 0,
    width: 186,
    height: 81,
    rx: 16
  }), /*#__PURE__*/React.createElement("text", {
    id: "Invoiced",
    fontFamily: "Helvetica-Bold, Helvetica",
    fontSize: 12,
    fontWeight: "bold",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 9,
    y: 22
  }, "Invoiced")))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisual);
export default __webpack_public_path__ + "static/media/Visual.e49214e1.svg";
export { ForwardRef as ReactComponent };